"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = exports.RegTxList = exports.RegListItem = exports.RegTxListRow = exports.MIN_TX_HEIGHT = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const react_device_detect_1 = require("react-device-detect");
const sharedStyles_1 = require("../sharedStyles");
const styles_1 = require("../TransactionPage/styles");
Object.defineProperty(exports, "MIN_TX_HEIGHT", { enumerable: true, get: function () { return styles_1.MIN_TX_HEIGHT; } });
exports.RegTxListRow = styled_components_1.default.div `
  display: flex;
  align-items: stretch;
  padding-left: ${({ theme }) => theme.mixins.register.rowInnerPadding}px;
  padding-right: ${({ theme }) => theme.mixins.register.rowInnerPadding}px;
  border-bottom: solid 1px ${({ theme }) => theme.palette.background.subtle};

  &.flashTx {
    animation: pulseTx 0.3s ease-in;
  }
  @keyframes pulseTx {
    0%, 100% {
      transform: translateY(0px);
    }
    50% {
      transform: translateY(10px);
    }
    70% {
      transform: translateY(20px);
    }
  }
  &.comfortable {
    min-height: ${styles_1.MIN_TX_HEIGHT.comfortable}px;
  }
  &.normal {
    min-height: ${styles_1.MIN_TX_HEIGHT.normal}px;
  }
  &.compact {
    min-height: ${styles_1.MIN_TX_HEIGHT.compact}px;
  }
  &.comfortable-ie {
    height: ${styles_1.MIN_TX_HEIGHT.comfortable}px;
    overflow: 'hidden';
  }
  &.normal-ie {
    height: ${styles_1.MIN_TX_HEIGHT.normal}px;
    overflow: 'hidden';
  }
  &.compact-ie {
    height: ${styles_1.MIN_TX_HEIGHT.compact}px;
    overflow: 'hidden';
  }
`;
exports.RegListItem = styled_components_1.default.div `
  &.popAmount {
    animation: pulse 0.5s ease-in;
  }
  @keyframes pulse {
    0%, 100% {
      transform: scale(1) translateX(0px);
    }
    50% {
      transform: scale(1.5) translateX(10px);
    }
  }
`;
exports.RegTxList = styled_components_1.default.div `
  margin-top: 0;
  opacity: 1;
  font-size: 12px;
  font-weight: 400;
  font-family: Roboto, sans-serif;
  background: ${({ theme }) => theme.palette.background.paper};

  border-bottom: none;
  border-width: 1px;
  border-bottom-width: 1px;
  border-color: ${({ theme }) => theme.palette.background.elevated};
  border-bottom-color: ${({ theme }) => theme.palette.background.elevated};

  &.appear {
    opacity: 1;
    transition: all 0.5s ease;
  }
  &:hover {
    background: ${react_device_detect_1.isMobile || react_device_detect_1.isTablet ? '' : ({ theme }) => theme.mixins.register.rowHoverColor};
    transition: .5s ease;
    borderRadius: 3px;
    cursor: 'default';
  }
  &.editable {
    background: ${({ theme }) => theme.mixins.register.editRowColor};
    &:hover: {
      background: ${({ theme }) => theme.mixins.register.editRowColor};
    }
  }
  &.pending {
  }
`;
const styles = (theme) => {
    var _a, _b, _c, _d, _e;
    return (Object.assign(Object.assign({}, (0, sharedStyles_1.sharedStyles)(theme)), { matchStateIcon: {
            display: 'flex',
            fontSize: '20px',
            '&.bank': {
                cursor: 'default',
                color: theme.palette.primary.main,
            },
            '&.manual': {
                cursor: 'default',
                color: theme.palette.primary.main,
            },
            '&.matched': {
                cursor: 'default',
                color: theme.palette.secondary.dark,
            },
            '&.scheduled': {
                cursor: 'default',
                color: theme.palette.other.dueTxn,
            },
        }, regPendingText: {
            color: theme.mixins.register.pendingTextColor,
        }, reviewed: {
            display: 'flex',
            cursor: 'pointer',
            color: theme.palette.text.tertiary,
            '&.not-reviewed': {
                color: theme.palette.info.main,
                fontSize: 'small',
            },
            '&.reviewed': {
                opacity: 1,
                color: theme.palette.text.disabled,
                fontSize: 'small',
            },
            '&.cancel': {
                opacity: 1,
                color: theme.palette.icon.secondary,
            },
            '&.save': {
                opacity: 0.8,
                color: theme.palette.icon.success,
            },
        }, notReviewed: {
            cursor: 'pointer',
        }, regInput: {
            color: theme.palette.text.strong,
            paddingBottom: '0px',
            paddingTop: 0,
            marginTop: '0px',
            fontSize: theme.mixins.register.fontSize.default,
            width: '100%',
            '& input': {
                padding: '0px',
                paddingBottom: '0px',
                fontSize: theme.mixins.register.fontSize.default,
                height: 24,
                '&::-ms-clear ': {
                    display: 'none',
                },
            },
        }, buttonRoot: {
            width: 'inherit',
            height: '100%',
            display: 'block',
        }, iconButton: {
            fontSize: '20px',
            padding: '6px',
        }, due: {
            color: theme.palette.other.dueTxn,
        }, overdue: {
            color: theme.palette.other.overdueTxn,
        }, notdue: {
            color: theme.palette.text.tertiary,
            opacity: 0.90,
        }, editHover: {
            '&:hover': {
                background: theme.mixins.register.fieldHoverColor,
            },
            '&:active': {
                border: `solid 1px ${theme.mixins.register.fieldBorderColor}`,
            },
        }, dateField: {
            fontSize: (_c = (_b = (_a = theme.mixins) === null || _a === void 0 ? void 0 : _a.register) === null || _b === void 0 ? void 0 : _b.fontSize) === null || _c === void 0 ? void 0 : _c.default,
        }, pending: {
            color: (_e = (_d = theme.components) === null || _d === void 0 ? void 0 : _d.register) === null || _e === void 0 ? void 0 : _e.pendingTextColor,
        }, bankOwnedPendingText: {
            fontStyle: 'italic',
            opacity: 0.60,
        }, txnInC2RText: {
            fontStyle: 'italic',
        }, bankPendingText: {
            opacity: 0.60,
        }, bankPending: {
            display: 'flex',
            cursor: 'pointer',
            color: theme.palette.text.tertiary,
            fontSize: '16px',
        }, accountColorDiv: {
            height: '100%',
            minHeight: 20,
            width: '40%',
        }, acceptBalanceButton: {
            color: 'steelBlue',
            cursor: 'pointer',
            fontWeight: 500,
            outline: 'none',
            fontStyle: 'normal',
            paddingTop: 2,
            paddingBottom: 2,
            minWidth: 50,
        }, balanceAmount: {
            paddingRight: 10,
        } }));
};
exports.styles = styles;
